import React from 'react'
import PropTypes from 'prop-types'
import { ErrorViewer } from 'components/error'

class ODataLoader extends React.Component {
  state = {
    loading: false,
    data: [],
    error: null
  }

  componentDidMount () { this.loadData() }
  componentDidUpdate (prevProps) {
    if (this.props.request !== prevProps.request) {
      this.loadData()
    }
  }

  loadData = () => {
    const { dataSource, request, odata } = this.props
    let req = request
    if (typeof (request) === 'function') { req = request() }

    new Promise((resolve, reject) => {
      this._reject = reject
      const now = Date.now()
      this.setState({ loading: true, error: null, requestedAt: now }, () => {
        dataSource(req).then(response => {
          resolve({ requestedAt: now, response: odata ? response.data : response }) 
        }).catch(reject)
      })
    }).then(r => {
      if (r.requestedAt >= this.state.requestedAt && !this._unmounting) {
        this.setState({
          loading: false,
          data: odata ? r.response.value : r.response,
          totalCount: odata ? r.response['@odata.count'] : -1,
          error: null
        })
      }
    }).catch(error => {
      if (!this._unmounting) {
        this.setState({ loading: false, error })
      }
    })
  }

  componentWillUnmount () {
    this._unmounting = true
    if (this._reject) { this._reject({ canceled: true }) }
  }
  render () {
    const { render, shouldPassError } = this.props
    if (this.state.error && !shouldPassError) return (<ErrorViewer error={this.state.error.message} onClick={this.loadData} />)
    if (typeof render === 'function') { return render(this.state) }
    return null
  }

}

ODataLoader.propTypes = {
  odata: PropTypes.bool
}
ODataLoader.defaultProps = {
  odata: true
}

export default ODataLoader
